'use strict'


import PopinManager from "./popinManage";
import Tracking from "./tracking";

const Panier = {
    eltPanier: null,
    overlay: null,
    txtLess: '',
    txtMore: '',
    txtDelete: '',
    txtAdded: '',
    items: [],
    init: function () {
        Panier.eltPanier = document.querySelector('.c-panier');
        Panier.overlay = document.querySelector('.overlay');
        if (Panier.eltPanier) {
            Panier.txtLess = Panier.eltPanier.getAttribute('data-less');
            Panier.txtMore = Panier.eltPanier.getAttribute('data-more');
            Panier.txtDelete = Panier.eltPanier.getAttribute('data-delete');
            Panier.txtAdded = Panier.eltPanier.getAttribute('data-added') || 'Ajouté au panier';
            Panier.event();
            Panier.renderPanier();
        }
    },
    event: function () {
        document.addEventListener('click', (e) => {
            if (e.target.matches('.c-buttonPanier') || e.target.closest('.c-buttonPanier')) {
                // Ouverture popin panier
                e.preventDefault();
                Panier.eltPanier.classList.add('open--');
                Panier.overlay.classList.add('show--');
                Panier.eltPanier.setAttribute('aria-hidden', 'false');
                document.body.classList.add("no-scroll");

                Tracking.bindViewCartTracking(Panier.items);

                // Accessibility
                Panier.eltPanier.querySelector('.c-panier__cta').removeAttribute('tabindex');
                Panier.eltPanier.querySelector('.c-panier__close').removeAttribute('tabindex');
                PopinManager.focusFirstElement(Panier.eltPanier);
                document.addEventListener("keydown", (e) => PopinManager.trapFocus(Panier.eltPanier, e, Panier.closePopin));
            }
            if (e.target.matches('.c-panier__close') || e.target.closest('.c-panier__close')) {
                // Fermeture popin Panier
                e.preventDefault();
                Panier.closePopin();
            }
            if (e.target.matches('.c-panier__cta') || e.target.closest('.c-panier__cta')) {
                Tracking.bindCheckoutCtaTracking(Panier.items);
            }
            if (e.target.matches('.addToCart') || e.target.closest('.addToCart')) {
                // Ajout au panier
                let button;
                if (e.target.matches('.addToCart')) {
                    button = e.target;
                } else {
                    button = e.target.closest('.addToCart');
                }
                e.preventDefault();

                // Bloque le clic pendant le feedback "Ajouté au panier"
                if (button.getAttribute('aria-disabled') === 'true') return;

                const id = button.getAttribute('data-id-publication');
                const title = button.getAttribute('data-title-publication');
                const img = button.getAttribute('data-image-publication');
                const maxAddToCart = button.getAttribute('data-max-order-publication') === "-1" ? 9999 : button.getAttribute('data-max-order-publication');
                const type = button.getAttribute('data-type-publication');
                const edition = button.getAttribute('data-edition-publication');
                Panier.addToCart(id, title, img, maxAddToCart, type, edition);
                Panier.showAddedFeedback(button);
            }
        });
    },
    closePopin: function () {
        Panier.eltPanier.classList.remove('open--');
        Panier.overlay.classList.remove('show--');
        Panier.eltPanier.setAttribute('aria-hidden', 'true');
        document.body.classList.remove("no-scroll");
        // Accessibility
        Panier.eltPanier.querySelector('.c-panier__cta').setAttribute('tabindex', '-1');
        Panier.eltPanier.querySelector('.c-panier__close').setAttribute('tabindex', '-1');
        document.removeEventListener("keydown", (e) => PopinManager.trapFocus(Panier.eltPanier, e, Panier.closePopin));
    },
    getPanier: function () {
        try {
            return JSON.parse(localStorage.getItem('cart')) || [];
        } catch (e) {
            return [];
        }
    },

    savePanier: function (panier) {
        Tracking.bindViewCartTracking(Panier.items);
        localStorage.setItem('cart', JSON.stringify(panier));
    },

    addToCart: function (id, title, img, maxAddToCart, type, edition) {
        let panier = Panier.getPanier();
        let found = panier.find(item => String(item.id).trim() === String(id).trim());

        if (found) {
            if (found.quantite < maxAddToCart) {
                found.quantite = parseInt(found.quantite, 10) + 1;
            }
        } else {
            if (maxAddToCart > 0) {
                panier.push({id, title, img, quantite: 1, maxAddToCart, type, edition});
            }
        }
        Panier.savePanier(panier);
        Panier.renderPanier();
    },
    renderPanier: function () {
        const panier = Panier.getPanier();
        const panierList = Panier.eltPanier.querySelector('.c-panier__list ul');
        const recapList = document.querySelector('.cart__recap ul');
        const cartList = document.querySelector('#list');
        const panierNumber = Panier.eltPanier.querySelector('.c-panier__number');
        const cartContent = document.querySelector('.cart__content');
        const cartEmpty = document.querySelector('.cart__empty');

        if (panier.length === 0) {
            if (cartContent) cartContent.classList.remove('show--');
            if (cartEmpty) cartEmpty.classList.add('show--');
        } else {
            if (cartContent) cartContent.classList.add('show--');
            if (cartEmpty) cartEmpty.classList.remove('show--');
        }

        let totalQuantite = 0;
        panierList.innerHTML = '';
        if (recapList) {
            recapList.innerHTML = '';
        }
        if (cartList) {
            cartList.value = JSON.stringify(panier.map(item => ({
                id: item.id,
                title: item.title,
                quantite: item.quantite
            })));
        }

        Panier.items = [];

        panier.forEach(item => {
            Panier.items.push({
                item_id: item.id,
                item_name: item.title,
                item_brand: 'Fondation ARC',
                item_category: item.type,
                item_category_2: item.edition,
                price: 0,
                quantity: item.quantite
            });
            totalQuantite += parseInt(item.quantite, 10);
            const li = document.createElement('li');
            li.setAttribute('data-id', item.id);
            li.setAttribute('data-type', item.type);
            li.setAttribute('data-edition', item.edition);
            li.setAttribute('data-title', item.title);
            li.innerHTML = `
                <img src="${item.img}" alt="">
                <div class="c-panier__list-item">
                    <div class="c-panier__list-item-title">${item.title}</div>
                    <div class="c-panier__actions">
                        <div class="c-inputNumber">
                            <button type="button" class="c-inputNumber__less" ${item.quantite <= 0 ? 'disabled' : ''} aria-label="${Panier.txtLess}"><i class="icon-less" aria-hidden="true"></i></button>
                            <input type="number" min="0" max="${item.maxAddToCart}" value="${item.quantite}" />
                            <button type="button" class="c-inputNumber__more" ${item.quantite >= item.maxAddToCart ? 'disabled' : ''} aria-label="${Panier.txtMore}"><i class="icon-more" aria-hidden="true"></i></button>
                        </div>
                        <button class="c-panier__delete c-buttonLink" data-id="${item.id}">${Panier.txtDelete}</button>
                    </div>
                </div>
            `;
            panierList.appendChild(li);
            if (recapList) {
                recapList.appendChild(li.cloneNode(true));
            }
        });

        panierNumber.textContent = totalQuantite;
        Panier.updateCtaState(totalQuantite);
        Panier.addEventListenersToButtons();
    },
    updateCtaState: function (totalQuantite) {
        const hasItems = totalQuantite > 0;
        document.querySelectorAll('.c-buttonPanier').forEach(button => {
            if (hasItems) {
                button.classList.add('notEmpty--');
            } else {
                button.classList.remove('notEmpty--');
            }
            let numberSpan = button.querySelector('.number');
            if (!numberSpan) {
                numberSpan = document.createElement('span');
                numberSpan.classList.add('number');
                button.appendChild(numberSpan);
            }
            // Lorsqu'on ajoute un article, on veut faire "bump" le nombre pour attirer l'attention de l'utilisateur
            numberSpan.classList.remove('bump');
            // Force reflow pour relancer l'animation si elle est déjà en cours
            void numberSpan.offsetWidth;
            numberSpan.classList.add('bump');
            setTimeout(() => {
                numberSpan.classList.remove('bump');
            }, 500);

            numberSpan.textContent = totalQuantite;
        });
    },
    showAddedFeedback: function (button) {
        const originalHTML = button.innerHTML;
        const FADE_DURATION = 200;

        const visuallyHidden = button.querySelector('.visuallyHidden');
        const visuallyHiddenHTML = visuallyHidden ? visuallyHidden.outerHTML : '';

        button.setAttribute('aria-disabled', 'true');

        // Créer un wrapper pour le contenu avec transition
        const wrapper = document.createElement('span');
        wrapper.style.cssText = 'display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; transition: opacity 0.2s ease-in-out;';
        wrapper.innerHTML = button.innerHTML;
        button.innerHTML = '';
        button.appendChild(wrapper);

        // Force reflow pour que la transition fonctionne
        void wrapper.offsetWidth;

        // Fade out du contenu uniquement → swap (sans icône, texte centré) → fade in
        wrapper.style.opacity = '0';
        setTimeout(() => {
            wrapper.innerHTML = `<span class="c-buttonCard__text">Ajouté<span> au panier</span>${visuallyHiddenHTML}</span>`;
            // Force reflow
            void wrapper.offsetWidth;
            wrapper.style.opacity = '1';
        }, FADE_DURATION);

        // Après 3s : fade out → restauration → fade in
        setTimeout(() => {
            wrapper.style.opacity = '0';
            setTimeout(() => {
                wrapper.innerHTML = originalHTML;
                // Force reflow
                void wrapper.offsetWidth;
                wrapper.style.opacity = '1';
                // Attendre la fin du fade in avant de nettoyer
                setTimeout(() => {
                    button.innerHTML = originalHTML;
                    button.removeAttribute('aria-disabled');
                }, FADE_DURATION);
            }, FADE_DURATION);
        }, 3000);
    },
    addEventListenersToButtons: function () {
        document.querySelectorAll('.c-inputNumber__less').forEach(button => {
            button.addEventListener('click', (e) => {
                const id = button.closest('li').getAttribute('data-id');
                Panier.updateQuantity(id, -1, e);
            });
        });
        document.querySelectorAll('.c-inputNumber__more').forEach(button => {
            button.addEventListener('click', (e) => {
                const id = button.closest('li').getAttribute('data-id');
                Panier.updateQuantity(id, 1, e);
            });
        });
        document.querySelectorAll('.c-inputNumber input').forEach(input => {
            input.addEventListener('change', (e) => {
                const id = e.target.closest('li').getAttribute('data-id');
                const newValue = parseInt(e.target.value, 10);
                Panier.updateQuantity(id, newValue - Panier.getPanier().find(item => item.id === id).quantite, e);
            });
        });
        document.querySelectorAll('.c-panier__delete').forEach(button => {
            button.addEventListener('click', (e) => {
                const id = e.target.closest('li').getAttribute('data-id');
                Tracking.handleQuantityDecrease(e, Panier.getPanier().find(item => item.id === id).quantite);
                Panier.removeFromCart(id);
            });
        });
    },
    updateQuantity: function (id, change, e) {
        let panier = Panier.getPanier();
        let item = panier.find(i => i.id === id);

        if (item) {
            let nouvelleQuantite = Math.max(0, Math.min(item.maxAddToCart, parseInt(item.quantite, 10) + change));
            if (nouvelleQuantite > parseInt(item.quantite, 10)) {
                Tracking.handleQuantityIncrease(e, nouvelleQuantite - parseInt(item.quantite, 10));
            } else {
                Tracking.handleQuantityDecrease(e, Math.abs(nouvelleQuantite - parseInt(item.quantite, 10)));
            }
            if (nouvelleQuantite > 0) {
                item.quantite = nouvelleQuantite;
            } else {
                panier = panier.filter(i => i.id !== id);
            }

            Panier.savePanier(panier);
            Panier.renderPanier();
        }
    },
    removeFromCart: function (id) {
        let panier = Panier.getPanier().filter(item => item.id !== id);
        Panier.savePanier(panier);
        Panier.renderPanier();
    }
};

export default Panier;
